import { render, staticRenderFns } from "./cxSliderItem.vue?vue&type=template&id=1901c704"
import script from "./cxSliderItem.vue?vue&type=script&lang=js"
export * from "./cxSliderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports